import React, { useState } from "react";
import ToastPopup from "./ToastPopup";
import { FunctionEditChecklistModalProps, createToastMessage, ToastMessage } from "../Interfaces/Interface";
const FunctionEditChecklistModal: React.FC<FunctionEditChecklistModalProps> = ({ isOpen, onClose, editableDetails, setEditableDetails, onSave, }) => {
  const [message, setMessage] = useState<ToastMessage | null>(null);
  if (!isOpen) return null;
  const handleSaveWithValidation = () => {
    const name = editableDetails?.functionTemplateName?.trim() || "";
    const desc = editableDetails?.functionDescription?.trim() || "";
    if (!name || !desc) {
      setMessage(createToastMessage("Please fill all fields", "warning", 3000));
      return;
    }
    if (name.length > 60) {
      setMessage(createToastMessage("Function Checklist Name cannot exceed 60 characters", "warning", 3000));
      return;
    }
    onSave();
  };
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Edit Function Checklist Item</h3>
        <label> Function Checklist Name:
          <textarea value={editableDetails?.functionTemplateName || ""} onChange={(e) => setEditableDetails((prev: any) => ({ ...prev, functionTemplateName: e.target.value }))} />
        </label>
        <label> Function Description:
          <textarea value={editableDetails?.functionDescription || ""} onChange={(e) => setEditableDetails((prev: any) => ({ ...prev, functionDescription: e.target.value }))} />
        </label>
        <div className="buttons">
          <button className="cancelbutton" onClick={onClose}>Cancel</button>
          <button className="savebutton" onClick={handleSaveWithValidation}>Save</button>
        </div>
        {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
      </div>
    </div>
  );
};
export default FunctionEditChecklistModal;